<div class="input-group ">
  <div class="w-100pc" *ngFor="let option of to.options" [ngClass]="option.class">
    <input type="radio" [name]="to.name" [formControl]="formControl" [formlyAttributes]="field" [value]="option.id"
      class="margin-right-10 align-middle svg-18 cursor-pointer">
    <span *ngIf="option?.value" [innerHTML]="sanitizerHtml(option.value)">
    </span>
  </div>

</div>